import { render, staticRenderFns } from "./FlowFrequency.modal.vue?vue&type=template&id=752187d9&"
import script from "./FlowFrequency.modal.vue?vue&type=script&lang=js&"
export * from "./FlowFrequency.modal.vue?vue&type=script&lang=js&"
import style0 from "./FlowFrequency.modal.vue?vue&type=style&index=0&id=752187d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports